<script>
// Inline SVG icon set for the student profile read/edit surfaces (DESIGN-10 /
// DESIGN-11 visual parity). No icon library, no font-icon: a single
// functional component rendering one of a small fixed set of stroked paths,
// scoped to src/components/StudentProfile/* only.
const PATHS = {
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8c0-3.31 3.13-6 7-6s7 2.69 7 6',
  bell:
    'M12 4a5 5 0 0 0-5 5v3.2L5 16h14l-2-3.8V9a5 5 0 0 0-5-5Zm-1.8 14a1.8 1.8 0 0 0 3.6 0',
  shield: 'M12 3 5 6v5c0 4.5 3 7.9 7 9 4-1.1 7-4.5 7-9V6l-7-3Z',
  headset:
    'M4 13v-1a8 8 0 0 1 16 0v1M4 13v3a2 2 0 0 0 2 2h1v-6H5a1 1 0 0 0-1 1Zm16 0v3a2 2 0 0 1-2 2h-1v-6h2a1 1 0 0 1 1 1Z',
  chevron: 'm9 6 6 6-6 6',
  back: 'm15 6-6 6 6 6',
  edit: 'M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3Zm9.5-11.5 3 3',
}

export default {
  name: 'StudentIcon',
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 20 },
  },
  render(h, { props }) {
    const d = PATHS[props.name]
    if (!d) return null
    return h(
      'svg',
      {
        attrs: {
          width: props.size,
          height: props.size,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': 1.8,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'aria-hidden': 'true',
          focusable: 'false',
        },
      },
      [h('path', { attrs: { d } })]
    )
  },
}
</script>
